var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('div',{attrs:{"id":"nav"}},[_c('router-link',{attrs:{"to":"/home"}},[_vm._v("Home")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/about"}},[_vm._v("About")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Logout")])],1),_c('h1',[_vm._v("This is an about page")])])
}
var staticRenderFns = []

export { render, staticRenderFns }